import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";
import { FragmentProvider } from "../../core/components/FragmentProvider";
import * as fragments from "./productFragments";

@Form({title: "Product Details Panel Config"})
export default class ProductDetailsConfig {

	@Input({type: InputType.CHECKBOX, title: "Show Related"})
	public showRelated: boolean;

	@Input({type: FragmentProvider.getInput(fragments), title: "Details"})
	public fragmetns: string[];

}



// WEBPACK FOOTER //
// ./src/panels/productDetails/ProductDetailsConfig.ts